// extracted by mini-css-extract-plugin
export var content = "_oa-1";
export var noScroll = "_oa-3";
export var paper = "_oa-0";
export var scrollable = "_oa-2";